import { render } from "./wallpaper.vue?vue&type=template&id=11557b0a&scoped=true"
import script from "./wallpaper.vue?vue&type=script&lang=js"
export * from "./wallpaper.vue?vue&type=script&lang=js"

import "./wallpaper.vue?vue&type=style&index=0&id=11557b0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11557b0a"]])

export default __exports__